import { createTranslations } from '@npco/utils-translations'

export const signUpSidebarTranslations = createTranslations({
  title: 'Replace your traditional business bank with Zeller.',
  subtitle: 'Signing up is free, and only takes minutes to complete.',
  benefit1: 'Free Transaction Accounts and Debit Cards.',
  benefit2: 'Affordable EFTPOS with no monthly rental fees.',
  benefit3: 'Send online invoices for free.',
  benefit4: 'No lock-in contracts.',
  benefit5: '7-day support via phone and email.',
  termsApply: '*Terms Apply',
})
